import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="payment"
export default class extends Controller {
  static targets = [
    "submit",
    "ccnumber",
    "ccexp",
    "cvv",
    "name",
    "zipcode",
    "nameError",
    "zipError",
    "cc_first_6",
    "cc_last_4",
    "exp_month",
    "exp_year",
    "paymentToken",
    "address",
    "addressError",
    "city",
    "cityError",
  ];

  connect() {
    this.submitButtonStatus = "pending";
    this.resetFields();
    this.configureCollect();
    this.watchTextInputs();
    this.validatePrefilledFields();
  }

  validatePrefilledFields() {
    const nameValue = this.nameTarget.value.trim();
    const zipValue = this.zipcodeTarget.value.trim();

    if (nameValue) {
      this.fieldsValid.name = true;
    } else {
      this.fieldsValid.name = false;
    }
    this.nameErrorTarget.textContent = nameValue ? "" : "Field is empty";

    if (zipValue) {
      this.fieldsValid.zipcode = true;
    } else {
      this.fieldsValid.zipcode = false;
    }
    this.zipErrorTarget.textContent = zipValue ? "" : "Field is empty";

    if (this.hasAddressTarget) {
      const addressValue = this.addressTarget.value.trim();
      if (addressValue) {
        this.fieldsValid.address = true;
      } else {
        this.fieldsValid.address = false;
      }
      this.addressErrorTarget.textContent = addressValue
        ? ""
        : "Field is empty";
    }

    if (this.hasCityTarget) {
      const cityValue = this.cityTarget.value.trim();
      if (cityValue) {
        this.fieldsValid.city = true;
      } else {
        this.fieldsValid.city = false;
      }
      this.cityErrorTarget.textContent = cityValue ? "" : "Field is empty";
    }

    this.updateSubmitState();
  }

  resetFields() {
    this.submitTarget.disabled = true;

    this.fieldsValid = {
      ccnumber: false,
      ccexp: false,
      cvv: false,
      name: false,
      zipcode: false,
    };

    if (this.hasAddressTarget) this.fieldsValid.address = false;
    if (this.hasCityTarget) this.fieldsValid.city = false;

    this.ccnumberTarget.textContent = "";
    this.ccexpTarget.textContent = "";
    this.cvvTarget.textContent = "";
    this.nameErrorTarget.textContent = "";
    this.zipErrorTarget.textContent = "";
  }

  configureCollect() {
    CollectJS.configure({
      invalidCss: {
        color: "#e74c3c",
      },
      validationCallback: (field, status, message) => {
        this.handleValidation(field, status, message);
      },
      callback: (response) => {
        const form = document.querySelector("form");

        const bin = response?.card?.bin || "";
        const maskedNumber = response?.card?.number || "";
        const last4 = maskedNumber.slice(-4);
        const exp = response?.card?.exp || "";
        const expMonth = exp.slice(0, 2);
        const expYear = exp.slice(2);

        this.cc_first_6Target.value = bin;
        this.cc_last_4Target.value = last4;
        this.exp_monthTarget.value = expMonth;
        this.exp_yearTarget.value = expYear;
        this.paymentTokenTarget.value = response.token;

        form.requestSubmit();
      },
    });
  }

  handleValidation(field, status, message) {
    this.fieldsValid[field] = status;
    this.updateSubmitState();

    switch (field) {
      case "ccnumber":
        this.ccnumberTarget.textContent = status ? "" : message;
        break;
      case "ccexp":
        this.ccexpTarget.textContent = status ? "" : message;
        break;
      case "cvv":
        this.cvvTarget.textContent = status ? "" : message;
        break;
    }
  }

  watchTextInputs() {
    this.nameTarget.addEventListener("input", () => {
      const value = this.nameTarget.value.trim();
      if (value) {
        this.fieldsValid.name = true;
      } else {
        this.fieldsValid.name = false;
      }
      this.nameErrorTarget.textContent = value ? "" : "Field is empty";
      this.updateSubmitState();
    });

    this.zipcodeTarget.addEventListener("input", () => {
      const value = this.zipcodeTarget.value.trim();
      if (value) {
        this.fieldsValid.zipcode = true;
      } else {
        this.fieldsValid.zipcode = false;
      }
      this.zipErrorTarget.textContent = value ? "" : "Field is empty";
      this.updateSubmitState();
    });

    if (this.hasAddressTarget) {
      this.addressTarget.addEventListener("input", () => {
        const value = this.addressTarget.value.trim();
        if (value) {
          this.fieldsValid.address = true;
        } else {
          this.fieldsValid.address = false;
        }
        this.addressErrorTarget.textContent = value ? "" : "Field is empty";
        this.updateSubmitState();
      });
    }

    if (this.hasCityTarget) {
      this.cityTarget.addEventListener("input", () => {
        const value = this.cityTarget.value.trim();
        if (value) {
          this.fieldsValid.city = true;
        } else {
          this.fieldsValid.city = false;
        }
        this.cityErrorTarget.textContent = value ? "" : "Field is empty";
        this.updateSubmitState();
      });
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    this.submitButtonStatus = "processing";
    this.submitTarget.disabled = true;
    this.submitTarget.value = "Processing...";
  }

  updateSubmitState() {
    if (this.submitButtonStatus === "processing") return;
    const requiredFields = Object.entries(this.fieldsValid)
      .filter(([_, value]) => value !== undefined)
      .map(([_, value]) => value);

    this.submitTarget.disabled = !requiredFields.every(Boolean);
  }
}
